export const Round = (num, decimalPlaces) => {
    var p = Math.pow(10, decimalPlaces || 0);
    var n = (num * p) * (1 + Number.EPSILON);
    return Math.round(n) / p;
}

